import {v4 as uuidv4} from 'uuid';

export class VideoChannel {
  constructor(
    public initiator: string,
    public id: string = uuidv4(),
    public title: string = '',
    public desc = '',
    public logo = '',
  ) {
  }
}
